<template>
  <fragment>
    <tr class="calendar-row" v-show="!(item.IS_HIDE || pHide)">
      <td style="white-space: nowrap;">
        <span
          style="display: block;float: left"
          :style="{ paddingRight: 12 * (lvl - 1) + 'px' }"
          >&nbsp;</span
        >
        <a
          class="add-t-r"
          v-show="editable"
          v-on:click="addItem"
          v-if="isMayHaveChild"
        ></a>
        <span
          style="display: block;float: left;margin: 0 7px 5px 0;width: 20px;height: 20px;"
          v-else
        ></span>
        <input
          style="width: 50px;padding: 0 4px"
          type="text"
          class="i-main-style"
          :value="pr + itemPos(idx)"
          disabled
        />
      </td>
      <template v-if="cptMode">
        <td
          class="stl-rg-15"
          :class="{
            'has-error': isErrorField(pr + itemPos(idx), 'UF_NAME')
          }"
        >
          <UiSelect v-model="item.UF_TPL_STAGE" @change="onCptStageChanged" :options="cptStageOptions"/>
        </td>
        <td
          class="stl-rg-15"
          :class="{
            'has-error': isErrorField(pr + itemPos(idx), 'UF_EXT_INFO')
          }"
        >
          <textarea
            v-model="item.UF_EXT_INFO"
            :disabled="!editable"
            @keyup="removeError(pr + itemPos(idx), 'UF_EXT_INFO')"
            class="i-main-style t-co-executor-style"
            style="width: 250px;height: 70px"
            maxlength="300"
          ></textarea>
        </td>
        <td
          class="stl-rg-15"
        >
          <CalendarCptSupportDoc v-model="item.DOCUMENTS"
                                 :template-stage="cptTemplateStage"
                                 :disabled="hasVisibleChild"
          />
        </td>
      </template>
      <template v-else>
        <td
          class="stl-rg-15"
          :class="{
            'has-error': isErrorField(pr + itemPos(idx), 'UF_NAME')
          }"
        >
          <textarea
            v-model="item.UF_NAME"
            :disabled="!editable"
            @keyup="removeError(pr + itemPos(idx), 'UF_NAME')"
            class="i-main-style t-co-executor-style"
            style="width: 250px;height: 70px"
          ></textarea>
      </td>
      </template>
      <td class="stl-rg-15">
        <ul style="list-style: none; padding-left: 0">
          <li
            style="white-space: normal; width: 300px; display: flex; align-items: flex-start"
            v-for="sp in directory.plan_istochnik_sp"
          >
            <input
              v-model="item.UF_ISTOCHNIK_ID"
              :disabled="hasDisabled"
              @change="onChangeIstochnik"
              type="checkbox"
              :value="sp.ID"
              style="margin-right: 5px;"
            />
            {{ sp.NAME }}
          </li>
        </ul>
      </td>
      <td
        v-if="!cptMode"
        class="stl-rg-15"
        :class="{
          'has-error': isErrorField(pr + itemPos(idx), 'UF_DOCUMENT')
        }"
      >
        <textarea
          v-model="item.UF_DOCUMENT"
          :disabled="!editable"
          class="i-main-style t-co-executor-style"
          @keyup="removeError(pr + itemPos(idx), 'UF_DOCUMENT')"
          style="width: 250px;height: 70px"
        ></textarea>
      </td>
      <fragment v-for="year in item.YEAR_DATA">
        <th class="calendar-row__year-th">
          <input
            :disabled="hasDisabled"
            type="checkbox"
            @change="checkForCheck($event, item, year.UF_YEAR, 1)"
            v-model="year.UF_KV1"
          />
        </th>

        <th class="calendar-row__year-th">
          <input
            :disabled="hasDisabled"
            type="checkbox"
            @change="checkForCheck($event, item, year.UF_YEAR, 2)"
            v-model="year.UF_KV2"
          />
        </th>

        <th class="calendar-row__year-th">
          <input
            :disabled="hasDisabled"
            type="checkbox"
            @change="checkForCheck($event, item, year.UF_YEAR, 3)"
            v-model="year.UF_KV3"
          />
        </th>

        <th class="calendar-row__year-th">
          <input
            :disabled="hasDisabled"
            type="checkbox"
            @change="checkForCheck($event, item, year.UF_YEAR, 4)"
            v-model="year.UF_KV4"
          />
        </th>
      </fragment>
      <td>
        <a @click="deleteItem" v-show="editable" class="link-delete-row"></a>
      </td>
    </tr>
    <CalendarRow
      v-show="!item.IS_HIDE || !pHide"
      :p-hide="item.IS_HIDE || pHide"
      v-for="(subitem, index) in items"
      :item="items[index]"
      :items="subitem.CHILD"
      :parent="item"
      :parent-items="items"
      :idx="parseInt(index) + 1"
      :lvl="lvl + 1"
      :pr="pr + '' + itemPos(idx) + '.'"
      :index-tree="indexTree + '.' + index"
      :calendar-years="calendarYears"
      :editable="editable"
      :save-errors="saveErrors"
      :cptMode="cptMode"
    ></CalendarRow>
  </fragment>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import UiSelect from "../../ui/UiSelect";
import CalendarCptSupportDoc from "./CalendarCptSupportDoc.vue";
import { stageHasVisibleChild } from "@/utils/plan";
import { NORMALIZE_CALENDAR_PLAN } from "@/store/actions.type";

export default {
  components: {
    UiSelect,
    CalendarCptSupportDoc,
  },
  props: [
    "item",
    "items",
    "idx",
    "lvl",
    "calendarYears",
    "pr",
    "indexTree",
    "editable",
    "parent",
    "parentItems",
    "pHide",
    "saveErrors",
    "cptMode"
  ],
  name: "CalendarRow",
  data() {
    return {
      showRender: true
    };
  },
  created() {
    if (this.item.YEAR_DATA === null) {
      this.item.YEAR_DATA = [];
      this.calendarYears.forEach(function(v) {
        this.item.YEAR_DATA.push({
          UF_PLAN_ROW_ID: this.item.ID,
          UF_KV1: 0,
          UF_KV2: 0,
          UF_KV3: 0,
          UF_KV4: 0,
          UF_YEAR: v
        });
      }, this);
    }
    this.checkForCheck();
    this.$store.dispatch(NORMALIZE_CALENDAR_PLAN);
  },
  computed: {
    hasDisabled() {
      // project.UF_SETTING может ещё не подгрузиться — не роняем рендер строки
      const setting = this.project && this.project.UF_SETTING;
      if ((setting && setting.IS_PLAN_ACCEPT == 1) || !this.editable) {
        return true;
      }

      if (this.items && this.items.length > 0) {
        let f = this.items.filter(c => c.IS_HIDE === false);
        if (f.length) {
          return true;
        }
      }
      return false;
    },
    cptStageOptions() {
      return [...this.calendarItems.CPT_ALL_STAGE_TEMPLATES]
        .filter(stage => stage.PARENT_ID == (this.parent || {}).UF_TPL_STAGE)
        .filter(stage => stage.LEVEL == this.lvl)
        .map(stage => ({
          id: stage.ID,
          name: stage.NAME,
        }));
    },
    cptTemplateStage() {
      return this.calendarItems.CPT_ALL_STAGE_TEMPLATES
        .find(stage => stage.ID == this.item.UF_TPL_STAGE);
    },
    // Можно ли создавать подэтапы?
    isMayHaveChild() {
      // Типизация КП
      if (this.cptMode) {
        // Если шаблона к подэтапу не найдено, то запретить создание
        const hasChildTemplate = this.calendarItems.CPT_ALL_STAGE_TEMPLATES
          .find(stage => stage.LEVEL == this.lvl + 1 && stage.PARENT_ID == this.item.UF_TPL_STAGE);

        if (!hasChildTemplate)
          return false;
      }

      // Общие правила

      // Вложенность больше двух недоступна (1, 2, 3)
      if (this.lvl >= 3)
        return false;

      return true;
    },
    hasVisibleChild() {
      return stageHasVisibleChild(this.item);
    },
    ...mapGetters(["directory", "calendarItems", "project"])
  },
  methods: {
    isErrorField(pos, field) {
      let f = this.saveErrors.filter(
        c => c.DOP_INFO.POSITION === pos && c.FIELDS === field
      );
      if (f.length) {
        return true;
      }
      return false;
    },
    removeError(pos, field) {
      this.saveErrors.forEach(function(c, k) {
        if (c.DOP_INFO.POSITION === pos && c.FIELDS === field) {
          this.saveErrors.splice(k, 1);
        }
      }, this);
    },
    itemPos(p) {
      let ret = 0;
      this.parentItems.forEach(function(c, k) {
        if (k >= p) {
          return;
        }
        if (c.IS_HIDE) {
          return;
        }

        ret++;
      });
      this.item.POSITION = this.pr + ret;
      this.item.UF_POSITION = ret;
      return ret;
    },
    checkForCheck(e, it, year, pos) {
      if (pos) {
        let needCheck = false;
        it.YEAR_DATA.forEach(function(item) {
          if (item.UF_YEAR < year && !needCheck) {
            for (let i = 1; i <= 4; i++) {
              if (item["UF_KV" + i] === true || needCheck) {
                needCheck = true;
                Vue.set(item, "UF_KV" + i, true);
              }
            }
          } else if (item.UF_YEAR < year && e.target.checked && needCheck) {
            item.UF_KV1 = true;
            item.UF_KV2 = true;
            item.UF_KV3 = true;
            item.UF_KV4 = true;
          }
          if (item.UF_YEAR === year) {
            if (needCheck) {
              for (let i = 1; i < pos; i++) {
                Vue.set(item, "UF_KV" + i, true);
              }
            }
            if (pos < 4) {
              for (let i = pos + 1; i <= 4; i++) {
                Vue.set(item, "UF_KV" + i, false);
              }
            }
          }
          if (item.UF_YEAR > year) {
            Vue.set(item, "UF_KV1", false);
            Vue.set(item, "UF_KV2", false);
            Vue.set(item, "UF_KV3", false);
            Vue.set(item, "UF_KV4", false);
          }
        }, this);

        //#56866
        const settingTable = this.project && this.project.SETTING_TABLE;
        const isAllowLongStagesKp = !!(
          settingTable &&
          settingTable.data &&
          settingTable.data.UF_IS_ALLOW_LONG_STAGES_KP == 1
        );
        let isFindAndSetNullCheck =
          it.CHILD.length == 0 && !isAllowLongStagesKp
            ? true
            : false;
        let countCheckLevel = 0;
        let isFlowBreak = false;
        let isFindCheck = false;

        if (isFindAndSetNullCheck) {
          console.log("все данные");
          console.log(it.YEAR_DATA);
          it.YEAR_DATA.forEach(function(item) {
            for (let i = 1; i <= 4; i++) {
              if (
                (item["UF_KV" + i] === true || item["UF_KV" + i] === 1) &&
                countCheckLevel > 3
              ) {
                Vue.set(item, "UF_KV" + i, false);
                countCheckLevel++;
              } else if (
                item["UF_KV" + i] === true ||
                item["UF_KV" + i] === 1
              ) {
                if (countCheckLevel == 0) {
                  isFindCheck = true;
                }
                if (isFlowBreak) {
                  Vue.set(item, "UF_KV" + i, false);
                } else {
                  countCheckLevel++;
                }
                console.log(item["UF_YEAR"] + " count " + countCheckLevel);
              } else {
                if (isFindCheck && countCheckLevel < 4) {
                  isFlowBreak = true;
                }
                Vue.set(item, "UF_KV" + i, false);
              }
            }
          }, this);

          if (countCheckLevel > 3 && !isFlowBreak) {
            e.target.checked = false;
            console.log(" countCheck " + countCheckLevel);
          } else if (isFlowBreak) {
            e.target.checked = false;
          }
        }
      }

      /*
      function firstCheck(items, c) {
        if (c === null) {
          c = {
            year: 99999
          }
        }
        if (items === null || items.length === 0) {
          return c;
        }
        items.forEach(function(item) {

        }
      }

       */

      function setCheck(items, year, r, i) {
        if (items === null || items.length === 0) {
          return r;
        }
        let tr = false;
        // String 1.1.1
        //  console.log(JSON.parse(JSON.stringify( items )));
        // console.log('это items - IS_HiDE: ', items )
        items.forEach(function(item) {
          if (item.IS_HIDE) {
            return;
          }
          // не позволяет проставлять галочки во всех checkbox
          // let isLast = false;
          // if (item.CHILD === null || item.CHILD.length === 0) {
          //   isLast = true;
          // }
          item.YEAR_DATA.forEach(function(d, y) {
            if (y === year) {
              if (tr) {
                r = true;
                return;
              }
              r = setCheck(item.CHILD, y, d[i], i);
              d[i] = r;
              if (!tr && r) {
                tr = true;
              }
            }
          });
          unhole(item.YEAR_DATA);
        });

        return r;
      }

      function setSource(items, r) {
        if (items === null || items.length === 0) {
          return r;
        }

        items.forEach(function(item) {
          if (item.IS_HIDE) {
            return;
          }
          let isLast = false;
          if (!stageHasVisibleChild(item)) {
            isLast = true;
          }
          if (isLast) {
            item.UF_ISTOCHNIK_ID.forEach(function(is) {
              let canAdd = true;
              r.forEach(function(ir) {
                if (ir === is) {
                  //canAdd = false;
                }
              });
              if (canAdd) {
                r.push(is);
              }
            });
          } else {
            item.UF_ISTOCHNIK_ID = setSource(item.CHILD, r);
          }
        });

        return r;
      }

      function unhole(items) {
        if (items === null || items.length === 0) {
          return;
        }
        let fy = 0;
        let fm = 0;
        let ly = 0;
        let lm = 0;
        items.forEach(function(d, y) {
          for (let i = 1; i <= 4; i++) {
            if (d["UF_KV" + i] === true) {
              if (fm === 0) {
                fy = y;
                fm = i;
              }
              ly = y;
              lm = i;
            }
          }
        });
        //console.log(fy, fm, ly, lm)
        if (lm > 0) {
          for (let y = fy; y <= ly; y++) {
            for (let i = 1; i <= 4; i++) {
              if (y === fy && i < fm) {
                continue;
              }
              if (y === ly && i > lm) {
                continue;
              }
              if (items[y]["UF_KV" + i] !== true) {
                Vue.set(items[y], "UF_KV" + i, true);
              }
            }
          }
        }
      }

      this.calendarItems.PLAN.forEach(function(item, k) {
        //this.calendarItems.PLAN[k].UF_ISTOCHNIK_ID = setSource(this.calendarItems.PLAN[k].CHILD, []);

        // console.log(JSON.parse(JSON.stringify(this.calendarItems.PLAN)));
        // console.log(JSON.parse(JSON.stringify(item.YEAR_DATA)));
        item.YEAR_DATA.forEach(function(d, y) {
          for (let i = 1; i <= 4; i++) {
            Vue.set(
              d,
              "UF_KV" + i,
              setCheck(item.CHILD, y, d["UF_KV" + i], "UF_KV" + i)
            );
          }
        });
        unhole(item.YEAR_DATA);
      }, this);
      //directory.plan_istochnik_sp
    },
    addItem() {
      // Если текущий элемент не имеет подэтапов, то создадим новый элемент с источниками текущего элемента, что бы
      // источники текущего элемента автоматически подтянулись из источников подэтапа, так как родительский этап
      // наследует от подэтапов список источников
      const newSourceIds = stageHasVisibleChild(this.item) ? [] : [...this.item.UF_ISTOCHNIK_ID];

      if (this.lvl == 1) {
        if (!this.calendarItems.PLAN[this.idx - 1].CHILD) {
          this.calendarItems.PLAN[this.idx - 1].CHILD = [];
        }
        this.calendarItems.PLAN[this.idx - 1].CHILD.push({
          ID: 0,
          UF_PARENT_ID: this.item.ID,
          UF_PROJECT_ID: this.project.ID,
          UF_NAME: "",
          UF_DOCUMENT: "",
          YEAR_DATA: null,
          IS_HIDE: false,
          UF_POSITION: this.calendarItems.PLAN[this.idx - 1].CHILD.length,
          UF_LEVEL: this.lvl + 1,
          CHILD: [],
          UF_ISTOCHNIK_ID: newSourceIds,
          UF_TPL_STAGE: null,

          // Используется при cptMode == true
          DOCUMENTS: [],
        });
      } else if (this.lvl < 3) {
        if (!this.items) {
          this.items = [];
        }
        this.items.push({
          ID: 0,
          UF_PARENT_ID: this.item.ID,
          UF_PROJECT_ID: this.project.ID,
          UF_NAME: "",
          UF_DOCUMENT: "",
          YEAR_DATA: null,
          IS_HIDE: false,
          UF_POSITION: this.items.length,
          UF_LEVEL: this.lvl + 1,
          CHILD: [],
          UF_ISTOCHNIK_ID: newSourceIds,
          UF_TPL_STAGE: null,

          // Используется при cptMode == true
          DOCUMENTS: [],
        });
      }
      this.$store.dispatch(NORMALIZE_CALENDAR_PLAN);
    },
    deleteItem() {
      // console.log(this.calendarItems);
      this.item.IS_HIDE = true;
      this.$store.dispatch(NORMALIZE_CALENDAR_PLAN);
    },
    onCptStageChanged() {
      // Очистить подтверждающие документы
      this.item.DOCUMENTS = [];

      // Удалять подэтапы при смене типа этапа
      for (const subitem of this.items) {
        subitem.IS_HIDE = true;
      }
    },
    onChangeIstochnik() {
      this.$store.dispatch(NORMALIZE_CALENDAR_PLAN);
    },
  }
};
</script>

<style scoped>
.calendar-row > td {
  vertical-align: top;
  padding-top: 8px;
}

.calendar-row__year-th {
  font-size: 12px;
  vertical-align: top;
  padding-top: 50px;
}
</style>
